module.exports = __webpack_public_path__ + "images/favicon.6f9ec21cc6a81d9800708d60d2d6f4b4.ico";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/favicon.ico
// module id = 1000
// module chunks = 0